export enum ImageType {
  DATABASE = 'DATABASE',
  FILE_SERVER = 'FILE_SERVER'
}
